<!--
 * @Description: 开票确认弹层
 * @Date: 2024-04-16 11:02:04
-->
<template>
  <el-dialog
    width="90%"
    class="chartDia"
    :show-close="false"
    @close="close"
    :visible="true"
    style="padding:0"
    id="openBill"
  >
    <div slot="title" class="slotTit">申请开票</div>
    <div class="table-box">
      <div class="colorBlock">开票信息</div>
      <div class="search-box">
        <div class="search-left">
          <div>
            <span>开票供应商：</span>
            <el-input
              class="search-input"
              disabled
              v-hovertip="billInfo.supplierName"
              :value="billInfo.supplierName"
            ></el-input>
          </div>
          <div>
            <span>开票类目：</span>
            <el-input
              class="search-input"
              disabled
              v-hovertip="billInfo.itemName"
              :value="billInfo.itemName"
            ></el-input>
          </div>
          <div>
            <span>发票类型：</span>
            <el-select
              v-hovertip="
                (taxList.find(item => item.value == billInfo.invoiceType) || {})
                  .label
              "
              :value="billInfo.invoiceType"
              placeholder="发票类型："
              disabled
              style="width:11.66vw"
            >
              <el-option
                v-for="item in taxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <span>发票抬头名称：</span>
            <el-input
              class="search-input"
              v-hovertip="billInfo.enterpriseName"
              :value="billInfo.enterpriseName"
              disabled
            />
          </div>
          <div>
            <span>联系电话：</span>
            <el-input
              class="search-input"
              v-hovertip="billInfo.enterprisePhone"
              :value="billInfo.enterprisePhone"
              disabled
            />
          </div>
          <div>
            <span>企业税号：</span>
            <el-input
              class="search-input"
              v-hovertip="billInfo.enterpriseIdentifierNo"
              :value="billInfo.enterpriseIdentifierNo"
              disabled
              clearable
            />
          </div>
          <div>
            <span>开户银行：</span>
            <el-input
              v-hovertip="billInfo.openBank"
              class="search-input"
              :value="billInfo.openBank"
              disabled
            />
          </div>
          <div>
            <span>企业地址：</span>
            <el-input
              v-hovertip="billInfo.enterpriseAddress"
              class="search-input"
              :value="billInfo.enterpriseAddress"
              disabled
            />
          </div>
          <div>
            <span>银行账号：</span>
            <el-input
              v-hovertip="billInfo.bankNo"
              class="search-input"
              :value="billInfo.bankNo"
              disabled
            />
          </div>
          <div v-if="billInfo._isSpecial">
            <span>开票方式：</span>
            <el-input
              class="search-input"
              :value="billInfo.invoiceMethod === 1 ? '电子发票' : '纸质发票'"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="colorBlock">发票邮寄信息</div>
      <div class="search-box">
        <div class="search-left">
          <!-- <div>
          <span>选择收件信息：</span>
          <el-input class="search-input" :value="billInfo.addressInfo.addressName" disabled></el-input>
        </div> -->
          <div>
            <span>收件人：</span>
            <el-input
              v-hovertip="billInfo.addressInfo.receiptFullName"
              class="search-input"
              :value="billInfo.addressInfo.receiptFullName"
              disabled
              clearable
            />
          </div>
          <div>
            <span>联系方式：</span>
            <el-input
              v-hovertip="billInfo.addressInfo.receiptPhone"
              class="search-input"
              :value="billInfo.addressInfo.receiptPhone"
              disabled
              clearable
            />
          </div>
          <div>
            <span>发票邮寄地址：</span>
            <el-input
              v-hovertip="billInfo.addressInfo.receiptAddress"
              class="search-input"
              :value="billInfo.addressInfo.receiptAddress"
              disabled
              clearable
            />
          </div>
          <div>
            <span>收件地址名称：</span>
            <el-input
              v-hovertip="billInfo.addressInfo.addressName"
              class="search-input"
              v-model="billInfo.addressInfo.addressName"
              disabled
              clearable
            />
          </div>
          <div>
            <span>电子邮箱：</span>
            <el-input
              v-hovertip="billInfo.addressInfo.email"
              class="search-input"
              v-model="billInfo.addressInfo.email"
              disabled
              clearable
            />
          </div>
        </div>
      </div>
      <div class="colorBlock">开票内容</div>
      <div class="totalMoney">
        <label>价税合计：</label>
        <span>{{ billInfo.curMoney | moneyFixed }}</span>
        <label>最大开票金额：</label>
        <span>{{ billInfo.totalAmount | moneyFixed }}</span>
      </div>
      <el-table
        :data="billInfo.selectedList"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
        ref="openList"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="项目名称"
          prop="projectName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="交易结构"
        >
          <template slot-scope="{ row }">
            {{ professionFilter(row.professionType) }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="订单编号"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="toFour(row)">
              {{ row.orderNo }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="订单类型"
        >
          <template slot-scope="{ row }">
            {{ invoiceOrderTypeFilter(row.invoiceOrderType) }}
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="projectName" label="项目名称"></el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="taskDt" label="详情">
        <template slot-scope="{ row }">{{row.invoiceOrderType==1?'项目支付':'综合服务费'}}：{{row.taskDt}}</template>
      </el-table-column> -->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="打款金额"
          key="taskDt"
        >
          <template slot-scope="{ row }">
            {{ row.projectPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="供应商收款时间"
        >
          <template slot-scope="{ row }">
            {{ row.createDt | transAllTime }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="billInfo.selectedList.length"
        :page-size="20"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
      <div
        style="margin:20px auto;display:flex;justify-content:space-around;width:30%;"
      >
        <el-button type="primary" @click="next">下一步</el-button>
        <el-button type="primary" plain @click="close">返回</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { makeSure } from '@/Mixin/makeSure';
import { invoice } from '@/api/ajax';
import { openTypeList, taxList, orderTypeList } from '@/config/staticData';
import { MessageBox } from 'element-ui';
import { PROFESSION_TYPE } from './invoiceTable/config/fields';

export default {
  mixins: [makeSure],
  props: {
    billInfo: {
      type: Object,
      default() {
        return { addressInfo: {} };
      }
    },
    // 123订单、综合 45平台、商务
    invoiceOrderType: { type: Number, default: 1 }
  },
  computed: {
    // 4 5类型
    is45() {
      return [4, 5].includes(this.invoiceOrderType);
    }
  },
  data() {
    return {
      openTypeList,
      orderTypeList,
      taxList,
      ProProp: {
        label: 'supplierName',
        code: 'supplierId'
      },
      typeProp: {
        label: 'itemName',
        code: 'id'
      },
      searchQuery: {
        supplierId: 0
      },
      gysList: [],
      loading: true,
      selectedList: [],
      setEmpty: 0,
      curMoney: ''
    };
  },

  methods: {
    invoiceOrderTypeFilter(invoiceOrderType) {
      if (this.is45) {
        return (
          { 4: '平台服务费发票', 5: '商务服务费发票' }[invoiceOrderType] || '-'
        );
      }
      return orderTypeList[invoiceOrderType - 1].label;
    },
    toFour(row) {
      // 跳转直接使用之前的确认提交里emit，用于关闭弹层
      this.$emit('confirm');
      this.$emit('remove');
      this.$router.push({
        path: '/orderMgmt/list',
        query: {
          orderNo: row.orderNo,
          part: 1,
          payType: row.payType
        }
      });
    },
    saveType(val) {
      this.ruleForm.itemId = val.id;
    },
    saveCompany(val) {
      this.searchQuery.supplierId = val.supplierId;
    },
    close() {
      this.$emit('remove');
    },
    async next() {
      const arr = [];
      for (let item of this.billInfo.selectedList) {
        arr.push(`${item.id}_${item.invoiceOrderType}`);
      }
      const orderIdType = arr.join(',');
      const orderIds = this.billInfo.selectedList
        .map(item => item.id)
        .join(',');
      let submitObj = {
        supplierId: this.billInfo.supplierId,
        itemId: this.billInfo.itemId,
        invoiceType: this.billInfo.invoiceType,
        invoiceMethod: this.billInfo.invoiceMethod,
        orderIdType,
        id: this.billInfo.addressInfo.id,
        // 服务费开票参数
        orderIds, // 开票内容列表的id  字符串以逗号隔开，去开票内容的id
        invoiceServicesItemId: this.billInfo.itemId // 类目id
      };
      await MessageBox.confirm('是否确认开票', '提示');
      const ajax = this.is45 ? 'saveServicesInvoice' : 'saveInvoice';
      await invoice[ajax](submitObj);
      this.$message({
        type: 'success',
        message: '保存成功'
      });
      this.$emit('confirm');
      this.$emit('remove');
    },
    professionFilter(profession) {
      return PROFESSION_TYPE.get(profession) || '-';
    }
  }
};
</script>
<style lang="scss" scoped>
.flexInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  img {
    max-width: 150px;
    margin-right: 10px;
  }
}
.colorBlock {
  font-size: 20px;
  line-height: 24px;
  display: flex;
  color: #2e2e2f;
  margin-bottom: 20px;
}
.colorBlock::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}
#openBill {
  .search-left {
    align-items: space-around;
    > div {
      display: flex;
      align-items: center;
      width: 400px;
      margin-right: 100px;
      span {
        width: 100px;
        text-align: right;
      }
    }
    .search-input {
      margin-right: 0;
      input {
        padding: 0;
      }
    }
  }
  .totalMoney {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 15px;
    label {
      font-size: 14px;
      color: #666;
    }
    span {
      font-size: 20px;
      color: #333;
    }
    span:first-of-type {
      margin-right: 112px;
    }
  }
}
</style>
